import { cn } from '@/lib/utils'
import { useModalFadeRef } from './modal-fade-presence'
import { forwardRef, type ComponentPropsWithoutRef } from 'react'

/** Keep modal clicks and form submissions from reaching the page that opened it. */
export const ModalEventBoundary = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<'div'>>(
  function ModalEventBoundary({ className, onClick, onSubmit, ...props }, ref) {
    const fadeRef = useModalFadeRef(ref)
    return <div data-state="open" {...props} className={cn('modal-fade', className)} ref={fadeRef}
      onClick={event => { event.stopPropagation(); onClick?.(event) }}
      onSubmit={event => { event.stopPropagation(); onSubmit?.(event) }} />
  },
)
